import { render, staticRenderFns } from "./ReferralsPendingPayouts.vue?vue&type=template&id=456bc1a0&"
import script from "./ReferralsPendingPayouts.vue?vue&type=script&lang=js&"
export * from "./ReferralsPendingPayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports